import type { Translate } from "app/filters/i18nFilter";

import { useTranslation } from "./I18n";

interface WithTranslationProps {
    children(translate: Translate): React.ReactNode;
}

const WithTranslation = ({ children }: WithTranslationProps) => {
    const translate = useTranslation();

    return children(translate);
};

export default WithTranslation;
